import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TruthSection() {
  return <section className="py-16 md:py-32 bg-[#0f1f38] relative" data-id="element-363">
      <div className="max-w-4xl mx-auto px-5 md:px-6" data-id="element-364">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-365">
          <FadeIn data-id="element-366">
            <h2 className="text-2xl md:text-5xl text-white leading-tight mb-4 md:mb-6" data-id="element-367">
              La verdad incómoda{' '}
              <span className="italic text-[#d4af37] block" data-id="element-368">
                (pero liberadora)
              </span>
            </h2>
            <div className="w-20 h-1 bg-[#d4af37] mb-6 md:mb-8" data-id="element-369" />
          </FadeIn>

          <FadeIn delay={0.1} className="space-y-4 md:space-y-6 text-base md:text-lg text-gray-300" data-id="element-370">
            <p data-id="element-371">
              Dios puede darte convicción… <br data-id="element-372" />
              <strong className="text-white text-lg md:text-xl" data-id="element-373">
                pero tú necesitas un sistema.
              </strong>
            </p>
            <p data-id="element-374">Porque la fe no se prueba en una emoción del domingo.</p>
            <p data-id="element-375">
              Se prueba el martes, con sueño, con estrés, con tentación, con mil
              cosas.
            </p>
            <p className="text-white font-medium border-l-4 border-[#d4af37] pl-4 italic" data-id="element-376">
              Y ahí es donde la mayoría se cae.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}